import { useQuery } from '@tanstack/react-query';
import { pnidApi } from '../api';
import { queryKeys } from '../queries/keys';

/** Whether this drawing has a plant-model graph the intelligence view can open. */
export function usePlantModelExists(docId: string | null | undefined): boolean {
  const query = useQuery({
    queryKey: queryKeys.plantModelExists(docId ?? ''),
    queryFn: () => pnidApi.hasPlantModel(docId!),
    enabled: Boolean(docId),
  });

  return query.data ?? false;
}
